document.addEventListener('turbo:load', () => {
  let toastElList = [].slice.call(document.querySelectorAll('.toast'))
  toastElList.map((toastEl) => {
    new Toast(toastEl).show()
  })
})
